<script>
import forminput from "../formcomponet/forminput.vue";
import formtextarea from "../formcomponet/formtextarea.vue";
import formcombobox from "../formcomponet/formcombobox.vue";
import formtreeselect from "../formcomponet/formtreeselect.vue";
import formdate from "../formcomponet/formdate.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import mznmezunlar from "@/models/mznmezunlar";

export default {
  mixins: [apibtoast, apigeneric, mznmezunlar],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,
    formcombobox,
    formtextarea,
    formdate,
    formtreeselect,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.FormData.Egitimbilgileri = JSON.parse(this.FormData.Egitimbilgileri);
      this.FormData.Isstajbilgileri = JSON.parse(this.FormData.Isstajbilgileri);
      this.FormData.Kursbilgileri = JSON.parse(this.FormData.Kursbilgileri);
      this.FormData.Sertifikabilgileri = JSON.parse(
        this.FormData.Sertifikabilgileri
      );
      this.FormData.Sinavbilgisi = JSON.parse(this.FormData.Sinavbilgisi);
      this.FormData.Yabancidilbilgisi = JSON.parse(
        this.FormData.Yabancidilbilgisi
      );
      this.FormData.Bilgisayarbilgisi = JSON.parse(
        this.FormData.Bilgisayarbilgisi
      );
      this.FormData.Yayinbilgilerim = JSON.parse(this.FormData.Yayinbilgilerim);
      this.FormData.Odulbilgileri = JSON.parse(this.FormData.Odulbilgileri);
      this.FormData.Projebilgileri = JSON.parse(this.FormData.Projebilgileri);
      this.FormData.Kulturelfaaliyetbilgileri = JSON.parse(
        this.FormData.Kulturelfaaliyetbilgileri
      );
      this.FormData.Dernekuyelikleri = JSON.parse(
        this.FormData.Dernekuyelikleri
      );
      this.FormData.Yetkinlikler = JSON.parse(this.FormData.Yetkinlikler);
      this.FormData.Referanslar = JSON.parse(this.FormData.Referanslar);
      this.FormData.Gizlilik = JSON.parse(this.FormData.Gizlilik);
   },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var FormData = this.FormData;
        FormData.Egitimbilgileri = JSON.stringify(FormData.Egitimbilgileri);
        FormData.Isstajbilgileri = JSON.stringify(FormData.Isstajbilgileri);
        FormData.Kursbilgileri = JSON.stringify(FormData.Kursbilgileri);
        FormData.Sertifikabilgileri = JSON.stringify(
          FormData.Sertifikabilgileri
        );
        FormData.Sinavbilgisi = JSON.stringify(FormData.Sinavbilgisi);
        FormData.Yabancidilbilgisi = JSON.stringify(FormData.Yabancidilbilgisi);
        FormData.Bilgisayarbilgisi = JSON.stringify(FormData.Bilgisayarbilgisi);
        FormData.Yayinbilgilerim = JSON.stringify(FormData.Yayinbilgilerim);
        FormData.Odulbilgileri = JSON.stringify(FormData.Odulbilgileri);
        FormData.Projebilgileri = JSON.stringify(FormData.Projebilgileri);
        FormData.Kulturelfaaliyetbilgileri = JSON.stringify(
          FormData.Kulturelfaaliyetbilgileri
        );
        FormData.Dernekuyelikleri = JSON.stringify(FormData.Dernekuyelikleri);
        FormData.Yetkinlikler = JSON.stringify(FormData.Yetkinlikler);
        FormData.Referanslar = JSON.stringify(FormData.Referanslar);
        FormData.Gizlilik = JSON.stringify(FormData.Gizlilik);
        if (this.AddEdit == "Add") {
          this.Post(this.$config.API_URL_2 + "mznmezunlar", FormData).then(
            (res) => {
              if (res) {
                this.$emit("TableUpdate");
                this.$bvModal.hide("mznmezunlar");
              }
            }
          );
        } else {
          this.Update(this.$config.API_URL_2 + "mznmezunlar", FormData).then(
            (res) => {
              if (res) {
                this.$emit("TableUpdate");
                this.$bvModal.hide("mznmezunlar");
              }
            }
          );
        }
      }
    },
    Get() {},
    FileUpload() {
      var file = this.$refs.file.files[0];
      let x = file.name;
      var uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      );
      if (uzanti == "png" || uzanti == "jpeg" || uzanti == "jpg") {
        let formData = new FormData();
        formData.append("file", file);
        this.ActionsPost({
          Service: "GenericFileUpDownload/UploadFile?pathUrl=Web",
          Data: formData,
        }).then((res) => {
          if (res.Succeeded == true) {
            this.FormData.Fotograf = res.Data.filename;
            this.$toast.success(this.$t("ToasMessage.FilePozitif"));
          } else {
            this.$toast.error(this.$t("ToasMessage.FileNegatif"));
          }
        });
      } else {
        this.$toast.error(this.$t("ToasMessage.FileNegatifUzanti"));
      }
    },
    EgitimbilgileriAdd() {
      this.FormData.Egitimbilgileri.push({
        Title: null,
        Okul: null,
        Fakülte: null,
        Bolum: null,
        Ogrenimdurumu: null,
        MezuniyetTarihi: null,
        DevamEdiyor: null
      });
    },
    EgitimbilgileriDel(index) {
      this.$delete(this.FormData.Egitimbilgileri, index);
    },
    IsstajbilgileriAdd() {
      this.FormData.Isstajbilgileri.push({
        Sektor: null,
        KurumKurulusAdi: null,
   //     KurumKurulusOlcegi: null,
        Departman: null,
        Pozisyon: null,
        BaslangıcYili: null,
        AyrılısYili: null,
     /*   IsYeriTelefon: null,
        Ulke: null,
        Il: null,
        Ilce: null,
        Adres: null,
        IsyeriSahibiyim: null, */
        HalenDevamEdiyor: null,
      });
    },
    IsstajbilgileriDel(index) {
      this.$delete(this.FormData.Isstajbilgileri, index);
    },
    KursbilgileriAdd() {
      this.FormData.Kursbilgileri.push({
        KursAdi: null,
        Kurum: null,
        BaslamaTarihi: null,
        BitisTarihi: null,
        Sure: null,
        Aciklama: null,
      });
    },
    KursbilgileriDel(index) {
      this.$delete(this.FormData.Kursbilgileri, index);
    },
    SertifikabilgileriAdd() {
      this.FormData.Sertifikabilgileri.push({
        Kategori: null,
        Tckimlikno: null,
        Turu: null,
        SertifikaAdi: null,
        Kurum: null,
        Tarih: null,
        BitisTarih: null,
        SaglananFaydaGelisim: null,
      });
    },
    SertifikabilgileriDel(index) {
      this.$delete(this.FormData.Sertifikabilgileri, index);
    },
    SinavbilgisiAdd() {
      this.FormData.Sinavbilgisi.push({
        SinavAdi: null,
        Yil: null,
        Not: null,
      });
    },
    SinavbilgisiDel(index) {
      this.$delete(this.FormData.Sinavbilgisi, index);
    },
    YabancidilbilgisiAdd() {
      this.FormData.Yabancidilbilgisi.push({
        Adi: null,
        Aciklama: null,
      });
    },
    YabancidilbilgisiDel(index) {
      this.$delete(this.FormData.Yabancidilbilgisi, index);
    },
    BilgisayarbilgisiAdd() {
      this.FormData.Bilgisayarbilgisi.push({
        Adi: null,
        Aciklama: null,
      });
    },
    BilgisayarbilgisiDel(index) {
      this.$delete(this.FormData.Bilgisayarbilgisi, index);
    },
    YayinbilgilerimAdd() {
      this.FormData.Yayinbilgilerim.push({
        YayininAdi: null,
        YayinlandigiYil: null,
        Tur: null,
        YayinlandigiKitapEvi: null,
      });
    },
    YayinbilgilerimDel(index) {
      this.$delete(this.FormData.Yayinbilgilerim, index);
    },
    OdulbilgileriAdd() {
      this.FormData.Odulbilgileri.push({
        OdulunAdi: null,
        OduluVerenKurum: null,
        OdulTarihi: null,
        Aciklama: null,
      });
    },
    OdulbilgileriDel(index) {
      this.$delete(this.FormData.Odulbilgileri, index);
    },
    ProjebilgileriAdd() {
      this.FormData.Projebilgileri.push({
        ProjeAdi: null,
        Kurum: null,
        Yil: null,
        Ozet: null,
        Aciklama: null,
      });
    },
    ProjebilgileriDel(index) {
      this.$delete(this.FormData.Projebilgileri, index);
    },
    KulturelfaaliyetbilgileriAdd() {
      this.FormData.Kulturelfaaliyetbilgileri.push({
        Adi: null,
        Tur: null,
        Duzey: null,
        TurAciklama:null
      });
    },
    KulturelfaaliyetbilgileriDel(index) {
      this.$delete(this.FormData.Kulturelfaaliyetbilgileri, index);
    },
    DernekuyelikleriAdd() {
      this.FormData.Dernekuyelikleri.push({
        Adi: null,
        Tur: null,
        Unvan: null,
      });
    },
    DernekuyelikleriDel(index) {
      this.$delete(this.FormData.Dernekuyelikleri, index);
    },
    YetkinliklerAdd() {
      this.FormData.Yetkinlikler.push({
        Adi: null,
        Aciklama: null,
      });
    },
    YetkinliklerDel(index) {
      this.$delete(this.FormData.Yetkinlikler, index);
    },
    ReferanslarAdd() {
      this.FormData.Referanslar.push({
        Adisoyadi: null,
        Unvan: null,
        CepTelefonu: null,
        Eposta: null,
      });
    },
    ReferanslarDel(index) {
      this.$delete(this.FormData.Referanslar, index);
    },
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="mznmezunlar"
      size="xl"
      :title="
        this.AddEdit == 'Edit'
          ? $t('mznmezunlar.AddEdit.FormTitleEdit')
          : $t('mznmezunlar.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">
        <div class="card">
          <div class="card-body border border-success">
            <div class="row">
                          <div class="col-md-6">
                          <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.KisiselBilgiler.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.DurumBilgiler"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.DurumBilgiler = $event"
                              />
                          </div>
                          </div>
            <div class="row">
              <div class="col-md-6">
                <forminput
                  :FormDataType="FormDataType.Tckimlikno"
                  :Value="FormData.Tckimlikno"
                  :v="$v.FormData.Tckimlikno"
                  @input="FormData.Tckimlikno = $event"
                />
              </div>
                            <div class="col-md-6">
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.TCKimlikNo"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.TCKimlikNo = $event"
                              />
                            </div>
   <!--           <div class="col-md-6">
                <formtreeselect
                  :FormDataType="FormDataType.Uyruk"
                  :Value="FormData.Uyruk"
                  :v="$v.FormData.Uyruk"
                  @input="FormData.Uyruk = $event"
                />
              </div> 
                            <div class="col-md-6">
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.Uyruk"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.Uyruk = $event"
                              />
                            </div> -->
              <div class="col-md-6">
                <forminput
                  :FormDataType="FormDataType.Adisoyadi"
                  :Value="FormData.Adisoyadi"
                  :v="$v.FormData.Adisoyadi"
                  @input="FormData.Adisoyadi = $event"
                />
              </div>
              <div class="col-md-6">
                <formcombobox
                  :FormDataType="FormDataType.Dogumyeri"
                  :Value="FormData.Dogumyeri"
                  :v="$v.FormData.Dogumyeri"
                  @input="FormData.Dogumyeri = $event"
                />
              </div>
              <div class="col-md-6">
                <formdate
                  :FormDataType="FormDataType.Dogumtarihi"
                  :Value="FormData.Dogumtarihi"
                  :v="$v.FormData.Dogumtarihi"
                  @input="FormData.Dogumtarihi = $event"
                />
              </div>
       <!--     <div class="col-md-6">
                <formcombobox
                  :FormDataType="FormDataType.Cinsiyet"
                  :Value="FormData.Cinsiyet"
                  :v="$v.FormData.Cinsiyet"
                  @input="FormData.Cinsiyet = $event"
                />
              </div> -->  
              <div class="col-md-6">
                <formtreeselect
                  :FormDataType="FormDataType.Yasadigiulke"
                  :Value="FormData.Yasadigiulke"
                  :v="$v.FormData.Yasadigiulke"
                  @input="FormData.Yasadigiulke = $event"
                />
              </div>
              <div class="col-md-6">
                <formcombobox
                  :FormDataType="FormDataType.Yasadigisehir"
                  :Value="FormData.Yasadigisehir"
                  :v="$v.FormData.Yasadigisehir"
                  @input="FormData.Yasadigisehir = $event"
                />
              </div>

     <!--         <div class="col-md-6">
                <formcombobox
                  :FormDataType="FormDataType.Medenidurum"
                  :Value="FormData.Medenidurum"
                  :v="$v.FormData.Medenidurum"
                  @input="FormData.Medenidurum = $event"
                />
              </div> -->

              <div class="col-md-6">
                <b-form-group
                  class="mb-3"
                  id="example text"
                  :label="FormDataType.Fotograf.FieldTitle"
                  label-for="text"
                  ><a
                    v-if="FormData.Fotograf"
                    :href="$config.FILES_URL + 'web/' + FormData.Fotograf"
                    target="_blanl"
                  >
                    Mevcut Resim
                  </a>
                  <input
                    class="form-control"
                    ref="file"
                    type="file"
                    v-on:change="FileUpload($event)"
                    id="FormData.Fotograf"
                    accept=".jpg, .jpeg, .png "
                  />
                </b-form-group>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
          
                            <div class="row">
                          <div class="col-md-6">
                          <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.DurumBilgileri.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.DurumBilgiler"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.DurumBilgiler = $event"
                              />
                        
                          </div>
                      
                          </div>

            <div class="row">
              <div class="col-md-6">
                <formcombobox
                  :FormDataType="FormDataType.Saglikengeli"
                  :Value="FormData.Saglikengeli"
                  :v="$v.FormData.Saglikengeli"
                  @input="FormData.Saglikengeli = $event"
                />
              </div>
              <div class="col-md-6">
                <formcombobox
                  :FormDataType="FormDataType.Saglikengelitipi"
                  :Value="FormData.Saglikengelitipi"
                  :v="$v.FormData.Saglikengelitipi"
                  @input="FormData.Saglikengelitipi = $event"
                />
              </div>
    <!--         <div class="col-md-6">
                <formcombobox
                  :FormDataType="FormDataType.Ehliyet"
                  :Value="FormData.Ehliyet"
                  :v="$v.FormData.Ehliyet"
                  @input="FormData.Ehliyet = $event"
                />
              </div> --> 
              <div class="col-md-6">
                <formcombobox
                  :FormDataType="FormDataType.Askerlik"
                  :Value="FormData.Askerlik"
                  :v="$v.FormData.Askerlik"
                  @input="FormData.Askerlik = $event"
                />
              </div> 
              <div class="col-md-6">
                <formcombobox
                  :FormDataType="FormDataType.Isaramadurumu"
                  :Value="FormData.Isaramadurumu"
                  :v="$v.FormData.Isaramadurumu"
                  @input="FormData.Isaramadurumu = $event"
                />
              </div>
              <div class="col-md-6">
                <formcombobox
                  :FormDataType="FormDataType.Calismadurumu"
                  :Value="FormData.Calismadurumu"
                  :v="$v.FormData.Calismadurumu"
                  @input="FormData.Calismadurumu = $event"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
     
<div class="row">
                          <div class="col-md-6">
                          <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.IletisimBilgileri.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.İletisimBilgiler"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.İletisimBilgiler = $event"
                              />
                          </div>
                          </div>
            <div class="row">
              <div class="col-md-6">
                <forminput
                  :FormDataType="FormDataType.Eposta"
                  :Value="FormData.Eposta"
                  :v="$v.FormData.Eposta"
                  @input="FormData.Eposta = $event"
                />
              </div>
              <div class="col-md-6">
                <forminput
                  :FormDataType="FormDataType.Telefon"
                  :Value="FormData.Telefon"
                  :v="$v.FormData.Telefon"
                  @input="FormData.Telefon = $event"
                />
              </div>
              <div class="col-md-6">
                <forminput
                  :FormDataType="FormDataType.Evadresi"
                  :Value="FormData.Evadresi"
                  :v="$v.FormData.Evadresi"
                  @input="FormData.Evadresi = $event"
                />
              </div>
   <!--           <div class="col-md-6">
                <forminput
                  :FormDataType="FormDataType.Website"
                  :Value="FormData.Website"
                  :v="$v.FormData.Website"
                  @input="FormData.Website = $event"
                />
              </div> 
              <div class="col-md-6">
                <forminput
                  :FormDataType="FormDataType.Facebook"
                  :Value="FormData.Facebook"
                  :v="$v.FormData.Facebook"
                  @input="FormData.Facebook = $event"
                />
              </div> -->
              <div class="col-md-6">
                <forminput
                  :FormDataType="FormDataType.Instagram"
                  :Value="FormData.Instagram"
                  :v="$v.FormData.Instagram"
                  @input="FormData.Instagram = $event"
                />
              </div>
              <div class="col-md-6">
                <forminput
                  :FormDataType="FormDataType.Twitter"
                  :Value="FormData.Twitter"
                  :v="$v.FormData.Twitter"
                  @input="FormData.Twitter = $event"
                />
              </div>
              <div class="col-md-6">
                <forminput
                  :FormDataType="FormDataType.Linkedin"
                  :Value="FormData.Linkedin"
                  :v="$v.FormData.Linkedin"
                  @input="FormData.Linkedin = $event"
                />
              </div>
    <!--        <div class="col-md-6">
                <forminput
                  :FormDataType="FormDataType.Isadresi"
                  :Value="FormData.Isadresi"
                  :v="$v.FormData.Isadresi"
                  @input="FormData.Isadresi = $event"
                />
              </div>
              <div class="col-md-6">
                <forminput
                  :FormDataType="FormDataType.Istelefonu"
                  :Value="FormData.Istelefonu"
                  :v="$v.FormData.Istelefonu"
                  @input="FormData.Istelefonu = $event"
                />
              </div> 
              <div class="col-md-6">
                <forminput
                  :FormDataType="FormDataType.Gerektigindeulasilacakkisi"
                  :Value="FormData.Gerektigindeulasilacakkisi"
                  :v="$v.FormData.Gerektigindeulasilacakkisi"
                  @input="FormData.Gerektigindeulasilacakkisi = $event"
                />
              </div> -->  
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
         
<div class="row">
                          <div class="col-md-6">
                         <h4 class="card-title mb-4">
                            {{ $t("mznmezunlar.AddEdit.Ozetbilgi.Title") }} 
                            - ( {{ FormData.Ozetbilgi ? FormData.Ozetbilgi.length : '0'}} / {{ $t("mznmezunlar.AddEdit.Ozetbilgi.Max") }} )
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.OzetBilgi"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.OzetBilgi = $event"
                              />
                          </div>
                          </div>

            <div class="row">
              <div class="col-md-12">
                <formtextarea
                  :FormDataType="FormDataType.Ozetbilgi"
                  :Value="FormData.Ozetbilgi"
                  :v="$v.FormData.Ozetbilgi"
                  @input="FormData.Ozetbilgi = $event"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
         

<div class="row">
                          <div class="col-md-6">
                         <h4 class="card-title mb-4">
              {{ $t("mznmezunlar.AddEdit.Kariyerhedefi.Title") }}
              - (
              {{
                FormData.Kariyerhedefi ? FormData.Kariyerhedefi.length : "0"
              }}
              / {{ $t("mznmezunlar.AddEdit.Kariyerhedefi.Max") }} )
            </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.KariyerHedefi"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.KariyerHedefi = $event"
                              />
                          </div>
                          </div>
            <div class="row">
              <div class="col-md-12">
                <formtextarea
                  :FormDataType="FormDataType.Kariyerhedefi"
                  :Value="FormData.Kariyerhedefi"
                  :v="$v.FormData.Kariyerhedefi"
                  @input="FormData.Kariyerhedefi = $event"
                  :max="20"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
                 
<div class="row">
                          <div class="col-md-6">
                    <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.Egitimbilgileri.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.EgitimBilgiler"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.EgitimBilgiler = $event"
                              />
                          </div>
                          </div>
            <b-button-group class="float-end">
              <b-button variant="success" @click="EgitimbilgileriAdd()"
                ><i class="mdi mdi-plus"></i>
              </b-button>
            </b-button-group>
            <div class="row">
              <div class="col-md-12">
                <div
                  class="card mt-2"
                  v-for="(Data, index) in FormData.Egitimbilgileri"
                  :key="index"
                >
                  <div class="card-body border border-success">
                    <b-button-group class="float-end">
                      <b-button
                        variant="danger"
                        @click="EgitimbilgileriDel(index)"
                        ><i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                    <div class="row">

                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Egitimbilgileri.Okul')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Okul"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                                      <b-form-group 
                                          :label="
                                            $t(
                                              'mznmezunlar.AddEdit.Egitimbilgileri.Ogrenimdurumu'
                                            )
                                          "
                                          label-for="text"
                                        >
                                          <select v-model="Data.Ogrenimdurumu" class="form-select">
                                            <option value="Ön lisans">Ön lisans</option>
                                            <option value="Yüksek lisans">Yüksek lisans</option> 
                                            <option value="Lisans">Lisans</option>
                                            <option value="Doktora">Doktora</option>
                                          </select>
                                        </b-form-group>
                                      </div>
                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Egitimbilgileri.Fakulte')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Fakülte"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4  mt-3">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Egitimbilgileri.Bolum')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Bolum"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-3  mt-3">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Egitimbilgileri.MezuniyetTarihi'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.MezuniyetTarihi"
                            for="text"
                            type="date"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-1"></div>
                      <div class="col-md-3 mt-3">
                                      <b-form-group
                                        :label="
                                          $t(
                                            'mznmezunlar.AddEdit.Egitimbilgileri.DevamEdiyor'
                                          )
                                        "
                                        label-for="text"
                                      >
                                        <b-form-checkbox
                                          v-model="Data.DevamEdiyor"
                                          value="Evet"
                                          unchecked-value="Hayır"
                                          plain
                                          class="col-md-2"
                                        ></b-form-checkbox>
                                      </b-form-group>
                                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
   
<div class="row">
                          <div class="col-md-6">
                    <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.Isstajbilgileri.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.IsStajBilgiler"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.IsStajBilgiler = $event"
                              />
                          </div>
                          </div>

            <b-button-group class="float-end">
              <b-button variant="success" @click="IsstajbilgileriAdd()"
                ><i class="mdi mdi-plus"></i>
              </b-button>
            </b-button-group>
            <div class="row">
              <div class="col-md-12">
                <div
                  class="card"
                  v-for="(Data, index) in FormData.Isstajbilgileri"
                  :key="index"
                >
                  <div class="card-body border border-success">
                    <b-button-group class="float-end">
                      <b-button
                        variant="danger"
                        @click="IsstajbilgileriDel(index)"
                        ><i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>

                    <div class="row">
                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Isstajbilgileri.Sektor')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Sektor"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Isstajbilgileri.KurumKurulusAdi'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.KurumKurulusAdi"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
             <!--       <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Isstajbilgileri.KurumKurulusOlcegi'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.KurumKurulusOlcegi"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div> -->  

                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Isstajbilgileri.Departman')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Departman"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>

                      <div class="col-md-4 mt-3">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Isstajbilgileri.Pozisyon')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Pozisyon"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>

                      <div class="col-md-4 mt-3">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Isstajbilgileri.BaslangıcYili'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.BaslangıcYili"
                            for="text"
                            type="date"
                          ></b-form-input>
                        </b-form-group>
                      </div>

                      <div class="col-md-4 mt-3">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Isstajbilgileri.AyrılısYili'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.AyrılısYili"
                            for="text"
                            type="date"
                          ></b-form-input>
                        </b-form-group>
                      </div>

          <!--            <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Isstajbilgileri.IsYeriTelefon'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.IsYeriTelefon"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>

                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Isstajbilgileri.Ulke')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Ulke"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>

                      <div class="col-md-4">
                        <b-form-group
                          :label="$t('mznmezunlar.AddEdit.Isstajbilgileri.Il')"
                          label-for="text"
                        >
                          <select v-model="Data.Il" class="form-select">
                            <option
                              v-for="DataArray in FormDataType.Yasadigisehir
                                .ComboDataArray"
                              :key="DataArray.Id"
                              :value="DataArray.Id"
                              :selected="Data.Il"
                            >
                              {{ DataArray.Value }}
                            </option>
                          </select>
                        </b-form-group>
                      </div>

                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Isstajbilgileri.Ilce')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Ilce"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>

                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Isstajbilgileri.Adres')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Adres"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Isstajbilgileri.IsyeriSahibiyim'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-checkbox
                            v-model="Data.IsyeriSahibiyim"
                            value="Evet"
                            unchecked-value="Hayır"
                            plain
                          ></b-form-checkbox>
                        </b-form-group>
                      </div> -->
                      <div class="col-md-4 mt-3">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Isstajbilgileri.HalenDevamEdiyor'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-checkbox
                            v-model="Data.HalenDevamEdiyor"
                            value="Evet"
                            unchecked-value="Hayır"
                            plain
                          ></b-form-checkbox>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
          

                              
<div class="row">
                          <div class="col-md-6">
                    <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.Kursbilgileri.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.KursBilgiler"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.KursBilgiler = $event"
                              />
                          </div>
                          </div>

            <b-button-group class="float-end">
              <b-button variant="success" @click="KursbilgileriAdd()"
                ><i class="mdi mdi-plus"></i>
              </b-button>
            </b-button-group>
            <div class="row">
              <div class="col-md-12">
                <div
                  class="card"
                  v-for="(Data, index) in FormData.Kursbilgileri"
                  :key="index"
                >
                  <div class="card-body border border-success">
                    <b-button-group class="float-end">
                      <b-button
                        variant="danger"
                        @click="KursbilgileriDel(index)"
                        ><i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                    <div class="row mt-2">
                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Kursbilgileri.KursAdi')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Bolum"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                          :label="$t('mznmezunlar.AddEdit.Kursbilgileri.Kurum')"
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Kurum"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>

                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Kursbilgileri.BaslamaTarihi'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.BaslamaTarihi"
                            for="text"
                            type="date"
                          ></b-form-input>
                        </b-form-group>
                      </div>

                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Kursbilgileri.BitisTarihi')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.BitisTarihi"
                            for="text"
                            type="date"
                          ></b-form-input>
                        </b-form-group>
                      </div>

                      <div class="col-md-4">
                        <b-form-group
                          :label="$t('mznmezunlar.AddEdit.Kursbilgileri.Sure')"
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Sure"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>

                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Kursbilgileri.Aciklama')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Aciklama"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
         
                              
<div class="row">
                          <div class="col-md-6">
                    <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.Sertifikabilgileri.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.SertifikaBilgiler"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.SertifikaBilgiler = $event"
                              />
                          </div>
                          </div>



            <b-button-group class="float-end">
              <b-button variant="success" @click="SertifikabilgileriAdd()"
                ><i class="mdi mdi-plus"></i>
              </b-button>
            </b-button-group>
            <div class="row">
              <div class="col-md-12">
                <div
                  class="card"
                  v-for="(Data, index) in FormData.Sertifikabilgileri"
                  :key="index"
                >
                  <div class="card-body border border-success">
                    <b-button-group class="float-end">
                      <b-button
                        variant="danger"
                        @click="SertifikabilgileriDel(index)"
                        ><i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                    <div class="row mt-2">

                      <div class="col-md-6">
                       <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Sertifikabilgileri.Kategori'
                            )
                          "
                          label-for="text"
                        >
                          <select v-model="Data.Kategori" class="form-select">
                            <option value="Sertifika">Sertifika</option>
                            <option value="Belge">Belge</option> 
                            <option value="Eğitim Programı">Eğitim Programı</option>
                          </select>
                        </b-form-group>
                      </div>
         <!--            <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Sertifikabilgileri.Tckimlikno'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Tckimlikno"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div> --> 
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Sertifikabilgileri.Turu')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Turu"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Sertifikabilgileri.SertifikaAdi'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.SertifikaAdi"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>

                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Sertifikabilgileri.Kurum')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Kurum"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>


                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Sertifikabilgileri.SaglananFaydaGelisim'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.SaglananFaydaGelisim"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Sertifikabilgileri.Tarih')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Tarih"
                            for="text"
                            type="date"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Sertifikabilgileri.BitisTarih')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.BitisTarih"
                            for="text"
                            type="date"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
          
                              
<div class="row">
                          <div class="col-md-6">
                    <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.Sinavbilgisi.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.SınavBilgiler"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.SınavBilgiler = $event"
                              />
                          </div>
                          </div>
            <b-button-group class="float-end">
              <b-button variant="success" @click="SinavbilgisiAdd()"
                ><i class="mdi mdi-plus"></i>
              </b-button>
            </b-button-group>
            <div class="row">
              <div class="col-md-12">
                <div
                  class="card"
                  v-for="(Data, index) in FormData.Sinavbilgisi"
                  :key="index"
                >
                  <div class="card-body border border-success">
                    <b-button-group class="float-end">
                      <b-button variant="danger" @click="SinavbilgisiDel(index)"
                        ><i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                    <div class="row mt-2">
                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Sinavbilgisi.SinavAdi')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.SinavAdi"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                          :label="$t('mznmezunlar.AddEdit.Sinavbilgisi.Yil')"
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Yil"
                            type="number"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                          :label="$t('mznmezunlar.AddEdit.Sinavbilgisi.Not')"
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Not"
                            type="number"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
        
            
                              
<div class="row">
                          <div class="col-md-6">
                    <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.Yabancidilbilgisi.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.YabanciDilBilgiler"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.YabanciDilBilgiler = $event"
                              />
                          </div>
                          </div>


            <b-button-group class="float-end">
              <b-button variant="success" @click="YabancidilbilgisiAdd()"
                ><i class="mdi mdi-plus"></i>
              </b-button>
            </b-button-group>
            <div class="row">
              <div class="col-md-12">
                <div
                  class="card"
                  v-for="(Data, index) in FormData.Yabancidilbilgisi"
                  :key="index"
                >
                  <div class="card-body border border-success">
                    <b-button-group class="float-end">
                      <b-button
                        variant="danger"
                        @click="YabancidilbilgisiDel(index)"
                        ><i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Yabancidilbilgisi.Adi')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Adi"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Yabancidilbilgisi.Aciklama')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Aciklama"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
                           
<div class="row">
                          <div class="col-md-6">
                    <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.Bilgisayarbilgisi.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.BilgisayarBilgiler"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.BilgisayarBilgiler = $event"
                              />
                          </div>
                          </div>
            <b-button-group class="float-end">
              <b-button variant="success" @click="BilgisayarbilgisiAdd()"
                ><i class="mdi mdi-plus"></i>
              </b-button>
            </b-button-group>
            <div class="row">
              <div class="col-md-12">
                <div
                  class="card"
                  v-for="(Data, index) in FormData.Bilgisayarbilgisi"
                  :key="index"
                >
                  <div class="card-body border border-success">
                    <b-button-group class="float-end">
                      <b-button
                        variant="danger"
                        @click="BilgisayarbilgisiDel(index)"
                        ><i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Bilgisayarbilgisi.Adi')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Adi"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Bilgisayarbilgisi.Aciklama')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Aciklama"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
           
                             
<div class="row">
                          <div class="col-md-6">
                    <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.Yayinbilgilerim.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.YayinBilgiler"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.YayinBilgiler = $event"
                              />
                          </div>
                          </div>


            <b-button-group class="float-end">
              <b-button variant="success" @click="YayinbilgilerimAdd()"
                ><i class="mdi mdi-plus"></i>
              </b-button>
            </b-button-group>
            <div class="row">
              <div class="col-md-12">
                <div
                  class="card"
                  v-for="(Data, index) in FormData.Yayinbilgilerim"
                  :key="index"
                >
                  <div class="card-body border border-success">
                    <b-button-group class="float-end">
                      <b-button
                        variant="danger"
                        @click="YayinbilgilerimDel(index)"
                        ><i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Yayinbilgilerim.YayininAdi')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.YayininAdi"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Yayinbilgilerim.YayinlandigiYil'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.YayinlandigiYil"
                            for="text"
                            type="number"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="$t('mznmezunlar.AddEdit.Yayinbilgilerim.Tur')"
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Tur"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Yayinbilgilerim.YayinlandigiKitapEvi'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.YayinlandigiKitapEvi"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
                              
                             
<div class="row">
                          <div class="col-md-6">
                    <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.Odulbilgileri.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.OdulBilgiler"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.OdulBilgiler = $event"
                              />
                          </div>
                          </div>


            <b-button-group class="float-end">
              <b-button variant="success" @click="OdulbilgileriAdd()"
                ><i class="mdi mdi-plus"></i>
              </b-button>
            </b-button-group>
            <div class="row">
              <div class="col-md-12">
                <div
                  class="card"
                  v-for="(Data, index) in FormData.Odulbilgileri"
                  :key="index"
                >
                  <div class="card-body border border-success">
                    <b-button-group class="float-end">
                      <b-button
                        variant="danger"
                        @click="OdulbilgileriDel(index)"
                        ><i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Odulbilgileri.OdulunAdi')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.OdulunAdi"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Odulbilgileri.OduluVerenKurum'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.OduluVerenKurum"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Odulbilgileri.OdulTarihi')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.OdulTarihi"
                            for="text"
                            type="date"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Odulbilgileri.Aciklama')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Aciklama"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
                       
                             
<div class="row">
                          <div class="col-md-6">
                    <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.Projebilgileri.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.ProjeBilgiler"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.ProjeBilgiler = $event"
                              />
                          </div>
                          </div>




            <b-button-group class="float-end">
              <b-button variant="success" @click="ProjebilgileriAdd()"
                ><i class="mdi mdi-plus"></i>
              </b-button>
            </b-button-group>
            <div class="row">
              <div class="col-md-12">
                <div
                  class="card"
                  v-for="(Data, index) in FormData.Projebilgileri"
                  :key="index"
                >
                  <div class="card-body border border-success">
                    <b-button-group class="float-end">
                      <b-button
                        variant="danger"
                        @click="ProjebilgileriDel(index)"
                        ><i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                    <div class="row mt-2">
                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Projebilgileri.ProjeAdi')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.ProjeAdi"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Projebilgileri.Kurum')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Kurum"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                          :label="$t('mznmezunlar.AddEdit.Projebilgileri.Yil')"
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Yil"
                            for="text"
                            type="number"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="$t('mznmezunlar.AddEdit.Projebilgileri.Ozet')"
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Ozet"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Projebilgileri.Aciklama')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Aciklama"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
                                          
<div class="row">
                          <div class="col-md-6">
                    <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.Kulturelfaaliyetbilgileri.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.KulturelBilgiler"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.KulturelBilgiler = $event"
                              />
                          </div>
                          </div>


            <b-button-group class="float-end">
              <b-button
                variant="success"
                @click="KulturelfaaliyetbilgileriAdd()"
                ><i class="mdi mdi-plus"></i>
              </b-button>
            </b-button-group>
            <div class="row">
              <div class="col-md-12">
                <div
                  class="card"
                  v-for="(Data, index) in FormData.Kulturelfaaliyetbilgileri"
                  :key="index"
                >
                  <div class="card-body border border-success">
                    <b-button-group class="float-end">
                      <b-button
                        variant="danger"
                        @click="KulturelfaaliyetbilgileriDel(index)"
                        ><i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Kulturelfaaliyetbilgileri.Adi'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Adi"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Kulturelfaaliyetbilgileri.Duzey'
                            )
                          "
                          label-for="text"
                        >
                          <select v-model="Data.Duzey" class="form-select">
                            <option value="Başlangıç">Başlangıç</option>
                            <option value="Orta">Orta</option> 
                            <option value="İleri">İleri</option>
                          </select>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Kulturelfaaliyetbilgileri.Tur'
                            )
                          "
                          label-for="text"
                        >
                          <select v-model="Data.Tur" class="form-select">
                            <option value="Hobi">Hobi</option>
                            <option value="Müzik Aleti">Müzik Aleti</option>
                            <option value="Sanat Dalı">Sanat Dalı</option>
                            <option value="Spor">Spor</option>
                            <option value="Diğer">Diğer</option>
                          </select>
                        </b-form-group>
                      </div>
                      
                      <div class="col-md-6" v-if="Data.Tur == 'Diğer'">
                        <b-form-group
                          :label="
                            $t(
                              'mznmezunlar.AddEdit.Kulturelfaaliyetbilgileri.TurAciklama'
                            )
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.TurAciklama"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
           
                                           
<div class="row">
                          <div class="col-md-6">
                    <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.Dernekuyelikleri.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.DernekBilgileri"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.DernekBilgileri = $event"
                              />
                          </div>
                          </div>




            <b-button-group class="float-end">
              <b-button variant="success" @click="DernekuyelikleriAdd()"
                ><i class="mdi mdi-plus"></i>
              </b-button>
            </b-button-group>
            <div class="row">
              <div class="col-md-12">
                <div
                  class="card"
                  v-for="(Data, index) in FormData.Dernekuyelikleri"
                  :key="index"
                >
                  <div class="card-body border border-success">
                    <b-button-group class="float-end">
                      <b-button
                        variant="danger"
                        @click="DernekuyelikleriDel(index)"
                        ><i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                    <div class="row mt-2">
                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Dernekuyelikleri.Adi')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Adi"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Dernekuyelikleri.Tur')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Tur"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Dernekuyelikleri.Unvan')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Unvan"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
                                         
<div class="row">
                          <div class="col-md-6">
                    <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.Yetkinlikler.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.YetkinlikBilgileri"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.YetkinlikBilgileri = $event"
                              />
                          </div>
                          </div>

            <b-button-group class="float-end">
              <b-button variant="success" @click="YetkinliklerAdd()"
                ><i class="mdi mdi-plus"></i>
              </b-button>
            </b-button-group>
            <div class="row">
              <div class="col-md-12">
                <div
                  class="card"
                  v-for="(Data, index) in FormData.Yetkinlikler"
                  :key="index"
                >
                  <div class="card-body border border-success">
                    <b-button-group class="float-end">
                      <b-button variant="danger" @click="YetkinliklerDel(index)"
                        ><i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <b-form-group
                          :label="$t('mznmezunlar.AddEdit.Yetkinlikler.Adi')"
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Adi"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Yetkinlikler.Aciklama')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Aciklama"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body border border-success">
          
                                          
<div class="row">
                          <div class="col-md-6">
                    <h4 class="card-title mb-4">
                            {{
                              $t("mznmezunlar.AddEdit.Referanslar.Title")
                            }}
                          </h4>
                          </div>
                          <div class="col-md-6">
                            
                              <formcombobox
                                :FormDataType="FormDataType.Gizlilik"
                                :Value="FormData.Gizlilik.ReferansBilgileri"
                                :v="$v.FormData.Gizlilik"
                                @input="FormData.Gizlilik.ReferansBilgileri = $event"
                              />
                          </div>
                          </div>



            <b-button-group class="float-end">
              <b-button variant="success" @click="ReferanslarAdd()"
                ><i class="mdi mdi-plus"></i>
              </b-button>
            </b-button-group>
            <div class="row">
              <div class="col-md-12">
                <div
                  class="card"
                  v-for="(Data, index) in FormData.Referanslar"
                  :key="index"
                >
                  <div class="card-body border border-success">
                    <b-button-group class="float-end">
                      <b-button variant="danger" @click="ReferanslarDel(index)"
                        ><i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Referanslar.Adisoyadi')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Adisoyadi"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="$t('mznmezunlar.AddEdit.Referanslar.Unvan')"
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Unvan"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="
                            $t('mznmezunlar.AddEdit.Referanslar.CepTelefonu')
                          "
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.CepTelefonu"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group
                          :label="$t('mznmezunlar.AddEdit.Referanslar.Eposta')"
                          label-for="text"
                        >
                          <b-form-input
                            v-model="Data.Eposta"
                            for="text"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button class="btn btn-primary" type="submit">
          {{ $t("mznmezunlar.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
